<template>
  <div class="share">
    <div class="share-top">
      <img :src="icon" />
      <div>
        <p>{{ name }}</p>
        <div class="type">{{ type }}</div>
      </div>
    </div>
    <div class="round" v-if="roundTitle">{{ roundTitle }}</div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: () => ''
    },
    icon: {
      type: String,
      default: () => ''
    },
    type: {
      type: String,
      default: () => ''
    },
    roundTitle: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
.share-top{
  display: flex; 
  background-color: #1E1E1E;
  padding: 12px;
  img{
    width: 45px;
    height: 45px;
    margin-right: 10px;
    border-radius: 5px;
  }
  p{
    color: #fff;
    font-weight: 800;
    margin: 0;
    margin-bottom: 5px;
  }
  .type{
    font-size: 12px;
    color: rgb(180, 180, 180);
  }
}
.round{
  text-align: center;
  font-size: 13px;
  padding: 6px 0;
}
</style>
